import { render, staticRenderFns } from "./KeyFour.vue?vue&type=template&id=570e92c2&scoped=true&"
import script from "./KeyFour.vue?vue&type=script&lang=js&"
export * from "./KeyFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570e92c2",
  null
  
)

export default component.exports